import { useIsAIChatExperiment } from '@ecomm/ai-chat/useIsAIChatExperiment'
import { useTranslation } from '@ecomm/i18n'
import { PhoneOutgoing } from '@ecomm/shared-icons'
import { useBusiness } from '@ecomm/smb-components/BusinessProvider/BusinessProvider'
import { AvailableTime } from '../CallSpecialistDropdownMenu/AvailableTime'

export function CallSpecialistSideNavContent() {
  const { isVariant, enabled: isChatEnabled } = useIsAIChatExperiment({})
  const isAIChatEnabled = isChatEnabled && isVariant

  const { t } = useTranslation('header')
  const RESIDENTIAL_PHONE_NUMBER_SPECIALIST = isAIChatEnabled
    ? '1-833-725-3250'
    : t('call-specialist-dropdown-menu.residential-phone-specialist')
  const BUSINESS_PHONE_NUMBER_SPECIALIST = t(
    'call-specialist-dropdown-menu.business-phone-specialist'
  )

  const { isBusiness } = useBusiness()

  const SPECIALIST_PHONE_NUMBER = isBusiness
    ? BUSINESS_PHONE_NUMBER_SPECIALIST
    : RESIDENTIAL_PHONE_NUMBER_SPECIALIST

  return (
    <div className="mt-6 mb-3 flex justify-between w-full">
      <div>
        <div>{t('call-specialist-dropdown-menu.call-sales-specialist')}</div>
        <div className="text-sm">{SPECIALIST_PHONE_NUMBER}</div>
        <AvailableTime />
      </div>
      <div>
        <PhoneOutgoing className="h-5 w-5" />
      </div>
    </div>
  )
}
